export const EMPTY_UUID = '00000000-0000-0000-0000-000000000000';
export const AUX_ADMIN_USER = '00000000-0000-0000-0000-000000000001';
export const ADMIN_METADATA_ID = '1';

export function isAuxUser(id: string) {
  return id === EMPTY_UUID || id === AUX_ADMIN_USER;
}
